<template>
    <section>
        <div class="free_flex">
            <div class="left_flex">
                <img width="545" height="440" src="~/assets/free-product/pendant.png" alt="free product pendant">
                <img width="545" height="440" src="~/assets/free-product/stud.png" alt="free product stud">
            </div>
            <div class="center_flex">
                <div>
                    <p class="mb-0 offer">Free Diamond Jewelry On <br> Purchases Over $3000!</p>
                    <div class="free_popup_block">
                        <div class="popup_btn" @click="showModal">Learn More</div>
                    
                        <div v-if="flagShowModal">
                            <Teleport  to="#teleports">
                                <div class="modal fade" data-bs-backdrop="true" id="termscondition" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="termscondition">
                                    <div class="modal-dialog modal-lg">
                                        <div class="modal-content  modal_body">                     
                                            <div class="title_block mb-2">
                                                <h5 class="mb-0 font-active">Terms & Conditions</h5>
                                                <span @click="hideModal"><SvgHeaderSvg type="close" class="largesvg" /></span>
                                            </div>
                                            <div class="">
                                                <FreeProductTerms />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Teleport>
                        </div>

                    </div>
                </div>

            </div>
          
        </div>
       
    </section>
</template>

<script setup>
    const flagShowModal = ref(false)
    const termscondition = ref(null)

    const showModal = () => {
            flagShowModal.value = true;
            nextTick(() => {
            const modalElement = termscondition.value;
            if (modalElement) {
            const modalInstance = new bootstrap.Modal(modalElement);
                modalInstance.show();
            }
            });
        };

        const hideModal = () => {
            const modalElement = termscondition.value;
            if (modalElement) {
                const modalInstance = bootstrap.Modal.getInstance(modalElement);
                if (modalInstance) {
                    modalInstance.hide();
                }
            }
            flagShowModal.value = false;
        };
</script>

<style scoped>
section {
    /* box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.15); */
    border: 1px solid #eaeaea;
    border-radius: 8px;
}
.free_flex {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

.left_flex {
    width: 40%;
    display: flex;
    align-items: center;
}
.left_flex img {
    width: 50%;
}
.center_flex {
    width: 60%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px;
}
/* h3 {
    font-size: 16px;
    color: #405955;
    text-transform: uppercase;
    font-weight: 600;
} */

p {
    color: #405955;
    font-size: 14px;
    line-height: 17px;
    font-weight: 600;
}
p span {
    font-weight: 600;
}
.free_popup_block {
    color: #606060;
    font-size: 14px;
    text-decoration: underline;
}

.popup_btn {
    cursor: pointer;
    font-size: 12px;
    color: #909090;
}

/* ---------------- */
.title_block{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.modal_body {
    padding: 4%;
}
.modal_body p {
    font-size: 14px;
    margin-bottom: 0;
    /* padding-top: 9px; */
    color: #6a6161;
    line-height: inherit;
    font-weight: normal;
    text-align: left;
}
.modal_body p span {
    font-weight: 600;
    color: #212529;
    font-size: 16px;
    display: block;
    margin-bottom: 8px;
}
.title_block span {
    cursor: pointer;
}
h5{
    font-size: 24px;
    text-align: center;
    color: #212529;
}
.largesvg {
    transform: scale(1.3);
}
/* ---------------- */

@media(max-width: 1024px){
    .free_flex {
        flex-wrap: wrap;
    }

    .left_flex {
        width: 65%;
        margin: 0 auto;
    }

    .center_flex {
        width: 100%;
    }
}

@media(max-width: 767px){
    h5{
        font-size: 16px;
    }
    .free_flex {
        flex-wrap: nowrap;
    }

    .left_flex {
        width: 40%;
    }

    .center_flex {
        width: 60%;
    }
}
</style>